import Vue from 'vue'
import Vuex from 'vuex'

import {ebus} from '../vendor/ebus';
import offers from './modules/offers'
import * as qconst from '../vendor/qconstants'
import {brandName, PROD_ENV, usecase$takeAway} from '../vendor/qconstants'
import coupons from './modules/coupons'
import stempelkarte from './modules/stempelkarte'
import kiosk from './modules/kiosk'
import menustore from './modules/menustore'
import stores from './modules/stores'
import flags from './modules/flags'
import discountsState from '../discounts/discountsState'
import {cloneMe, displayCouponType, isEmptyObject, mapEquals} from "@/vendor/util";
import * as storeHelper from './storeHelper'
import {getGlobalValue} from "@/util/globalState";


Vue.use(Vuex)

function getAvailableOrderModes(state, rootGetters) {
  let modes = [];
  if (rootGetters.isKiosk) {
    if (rootGetters.enableKioskInhouseOhnePay || rootGetters.enableKioskInhouseMitPay) {
      modes.push('inhouse');
    }
    if (rootGetters.enableKioskTakeAwayOhnePay || rootGetters.enableKioskTakeAwayMitPay) {
      modes.push('takeAway');
    }
  } else {
    if (rootGetters.enableInhouseOhnePay || rootGetters.enableInhousePay) {
      if ((!!rootGetters.selectedOrderModeByUser && rootGetters.selectedOrderModeByUser !== 'takeAway' && rootGetters.selectedOrderModeByUser !== 'delivery') || !state.hideInhouseForTakeaway) {
        modes.push('inhouse');
      }
    }
    if (rootGetters.enableTakeawayOhnePay || rootGetters.enableTakeawayPay) {
      if (rootGetters.selectedOrderModeByUser !== 'inhouse' || !state.hideTakeawayForInhouse) {
        modes.push('takeAway');
      }
    }
    if (rootGetters.enableDeliveryOhnePay || rootGetters.enableDeliveryPay) {
      if (rootGetters.selectedOrderModeByUser !== 'inhouse' || !state.hideTakeawayForInhouse) {
        modes.push('delivery');
      }
    }
  }

  return modes;
}

function findParentCatByItem(item) {
  let menu = null;
  if (item.type === qconst.type$foodOrder) {
    menu = menustore.state.foodMenu;
  } else {
    menu = menustore.state.drinkMenu;
  }
  if (menu) {
    for (let cat of menu) {
      try {
        let found = cat.items.find(u => u.id === item.id);
        if (found) {
          let r = cloneMe(cat);
          delete r.items;
          return r;
        }
      } catch (what) {
        console.log('error what: ' + what.message);
      }
    }
  }

  return null;
}

function doUpdateOrder(state, _order) {
  let order = cloneMe(_order);
  // prepareOrder(order);

  let o = state.lastOrders.find(o => o.uniqueOrderId === order.uniqueOrderId);
  if (o) {
    if (o.kasseFertig) {
      order.kasseFertig = true;
    }
    if (o.abholbereit) {
      order.abholbereit = true;
    }
    if (o.getraenkeAbholbereit) {
      order.getraenkeAbholbereit = true;
    }
    // if (o.storno) {
    //   order.storno = true;
    // }
    if (o.captureId) {
      order.captureId = o.captureId;
    }
    if (o.capturedAt) {
      order.capturedAt = o.capturedAt;
    }
    if (o.authCompleted) {
      order.authCompleted = o.authCompleted;
    }
    if (o.authCompletedAt) {
      order.authCompletedAt = o.authCompletedAt;
    }
    if (o.paid) {
      order.paid = o.paid;
    }
    if (o.checkoutId) {
      order.checkoutId = o.checkoutId;
    }
    if (o.sentToPos) {
      order.sentToPos = o.sentToPos;
    }
    if (o.chargeId) {
      order.chargeId = o.chargeId;
    }
    if (o.charged) {
      order.charged = o.charged;
    }

    //autoabholbereit
    if (state.enableAutoAbholbereit && o.usecase === usecase$takeAway) {
      if (Date.now() - o.targetTime > 0) {
        order.abholbereit = true;
      }
    }

    let cloneBefore = cloneMe(o);
    Object.assign(o, order);
    let cloneAfter = cloneMe(o);

    console.log('updateOrder completed value ' + JSON.stringify(order));

    if (!mapEquals(cloneBefore, cloneAfter)) {
      ebus.$emit('orderUpdated', o);
    }

  } else {
    if (order.orderData) {
      state.lastOrders.push(order);
    }
  }
}

function updateCartSum(state) {
  //update cartSum
  let s = storeHelper.calcCartSum(cloneMe(state.cartItems));
  console.log('cartItem sums: ' + JSON.stringify(s));
  state.cartSum = s.cartSum;
  state.payerSum = s.payerSum;
  state.takeAwayPayerSum = s.takeAwayPayerSum;
  state.rabattSum = s.rabattSum;
  state.drinkSum = s.drinkSum;
}

function getItemById(categories, itemId) {
  for (let category of categories) {
    let item = category.items.find(u => u.id === itemId);
    if (item) {
      return item
    }
  }
  return null;
}

function gangEquals(itm1, itm2) {
  return ('' + itm1.gang) === ('' + itm2.gang);
}

function showAdded() {
  ebus.$emit('triggerShowAdded');
  ebus.$emit('itemAdded');
  ebus.$emit('wasAdded');
}

function checkInventoryData(state, item) {
  if (!state.enableBestand) {
    return true;
  }
  let inventoryData = getGlobalValue('inventoryData') || [];
  if (inventoryData?.length) {
    // let itemIdType = item.id + '_' + item.type;
    const posId = item.posId;
    console.log('addItemToCard check 4.0 for posId: ' + posId);
    let iData = inventoryData.find(i => i.posId === posId);
    if (iData) {
      if (iData.currentStock <= 0) {
        ebus.$emit('showInfo', {
          title: 'Der Artikel <span style="text-decoration: underline;">'
            + item.nameToDisplay + '</span> ist ausverkauft!',
          text: ''
        });
        return false;
      } else if (item.posId) {
        const existingCartItems = state.cartItems.filter(cItem => cItem.posId === item.posId);
        let cartStock = 0;
        for (let eItem of existingCartItems) {
          cartStock += eItem.count;
        }
        if (1 + cartStock > iData.currentStock) {
          ebus.$emit('showInfo', {
            title: 'Der Artikel <span style="text-decoration: underline;">'
              + item.nameToDisplay + '</span> ist fast ausverkauft: Nur noch ' + iData.currentStock + ' Artikel verfügbar',
            text: ''
          });
          return false;
        }
      }
    }
  }
  return true;
}

// Vue.config.devtools = true;
export default new Vuex.Store({
  modules: {
    offers,
    coupons,
    stempelkarte,
    kiosk,
    menustore,
    stores,
    flags,
    discountsState,
  },
  state: {
    brandName: brandName,

    showCatSlider: true,
    showSearch: true,
    showSearchFilter: false,
    secToken: 'deactivated',

    // defaultPlz: '01999',
    // defaultCity: 'Maxstadt',
    staticDisplayAbholung: 'Käthe-Kolwitz-Str. 12, 04109 Leipzig 44',

    //Catering-Mode / all you can eat
    hidePrices: false,

    enableBiggerButtonsForOnlinePay: true,
    enableMehrwegOption: false,
    mehrwegCompanyName: 'XY',
    enableKellnerruf: false,
    enableNews: false,
    showItemDaysAvailability: false,
    enableRatingFeedback: false,
    enableCoupons: false,
    enableEnterCode: true,
    enableSelfServiceExtras: true,
    enableFavs: true,
    enableBestand: false,
    enableBestandanzeigeInItemList: true,
    enableAccount: true,
    enableTip: true,
    enableItemNote: true,
    enableOrderNote: true,
    showPlaceholders: false,
    enableOrderModeSelection: true,
    enableOrderModeSelectionWithTime: false,
    hideOrderModeSelectionForASingleModeOnHomeScreen: true,
    forceOrderModeSelectionOnOpen: false,
    hideInhouseForTakeaway: true,
    hideTakeawayForInhouse: true,
    defaultInhouseTable: 888,
    enableAutoAbholbereit: true,

    globals: {},

    currentItemId: '',

    scrollTarget: '',
    deviceClass: '',

    orderArea: '',

    onlineServiceFee: 0,

    showSelectFiliale: false,
    continueBack: '', //back menas history back

    //only for iframes
    // yA:0, //the offset from the top required for elements to appear centered outsite the iframe

    appContext: {
      bar: false,
      stripe: true,
      paypal: true,
    },

    swActive: false,

    page: '',

    pages: [],

    hideScroll: false,
    hideToolbar: false,
    showSearchIcon: true,

    appLoaded: false,
    searchBarVisible: false,
    lastOrders: [],

    barTitle: '',

    inhouse: false,//only true of the app has been opened with the query parameter or inhouse domain
    table: 0,

    cartId: '',
    fromWidget: false,

    //will trigger jumpToTup in activated of target page
    shouldJump: false,

    selectedCategory: {id: '', categoryDE: ''},
    duringCatSelect: false,
    //needed for usecase takeaway
    selectedOrderModeByUser: '', // inhouse | takeAway | delivery | null
    selectedTime: {
      value: '',
      display: '',
      utc: 0
      // value: h + ':' + minute,
      // display: h + ':' + minute + ' Uhr',
      // utc: nd.getTime()
    },

    loginPostprocessing: false,
    isLoggingOut: false,
    loggedIn: false,
    duringRegistration: false,

    remoteTime: {
      /*
      time.put("year", now.getYear());
      time.put("month", now.getMonthValue());
      time.put("date", now.getDayOfMonth());
      time.put("day", now.getDayOfWeek().getValue());
      time.put("hour", now.getHour());
      time.put("minute", now.getMinute());
       */
      date: 17,
      day: 5,
    },
    openingBegin: '',

    cartProtected: false,

    selectedPickupTime: 0,

    cartItems: [],
    appliedDiscounts: [],
    cartSum: 0,
    payerSum: 0,
    drinkSum: 0,
    takeAwayPayerSum: 0,
    rabattSum: 0,

    //caculating result from takeawayData update
    day1: {
      opened: false,
//             a: {fromHour: 11, fromMinute: 15, tillHour: 23, tillMinute: 30}
// //               b: {fromHour: 11, fromMinute: 15, tillHour: 23, tillMinute: 30}
    },
    day2: {opened: false},
    day3: {opened: false},

    //filled per stores
    appconfig: {
      // all: {
      loaded: false,
      orderingEnabled: true,
      inhouseOrderingEnabled: false,
      takeawayOrderingEnabled: false,
      deliveryOrderingEnabled: false,
      selfServiceEnabled: true,
      userInfo: '',
      globalExtras: [],
      delayInMinutes: 20,
      minOrderAmount: 0,
      openingHours: {
        // "1" : {
        //     "opened" : true,
        //     "a" : {
        //         "fromHour" : 5,
        //         "fromMinute" : 30,
        //         "tillHour" : 18,
        //         "tillMinute" : 0
        //     },
        //     "b" : {
        //         "fromHour" : -1,
        //         "fromMinute" : -1,
        //         "tillHour" : -1,
        //         "tillMinute" : -1
        //     }
        // },
      },
      takeAway: {
        // loaded: false, // gets updated by the selectedStore mutation
        //   filialnummer: '',
        //   orderingEnabled: true,
        delayInMinutes: 5,
        minOrderAmount: 0,
        openingHours: {
          //     // "1" : {
          //     //     "opened" : true,
          //     //     "a" : {
          //     //         "fromHour" : 5,
          //     //         "fromMinute" : 30,
          //     //         "tillHour" : 18,
          //     //         "tillMinute" : 0
          //     //     },
          //     //     "b" : {
          //     //         "fromHour" : -1,
          //     //         "fromMinute" : -1,
          //     //         "tillHour" : -1,
          //     //         "tillMinute" : -1
          //     //     }
        },
      },
      //   },
      delivery: {
        // loaded: false, // gets updated by the selectedStore mutation
        //   orderingEnabled: true,
        deliveryFee: 0,
        delayInMinutes: 5,
        minOrderAmount: 0,
        openingHours: {
          //     // "1" : {
          //     //     "opened" : true,
          //     //     "a" : {
          //     //         "fromHour" : 5,
          //     //         "fromMinute" : 30,
          //     //         "tillHour" : 18,
          //     //         "tillMinute" : 0
          //     //     },
          //     //     "b" : {
          //     //         "fromHour" : -1,
          //     //         "fromMinute" : -1,
          //     //         "tillHour" : -1,
          //     //         "tillMinute" : -1
          //     //     }
          //     // },
        },
      },

      // }
    },

    user: {
      fuid: '',
      name: '',
      email: '',
      emailVerified: '',
      phone: ''
    },

    stripeLoaded: false,
    stripeCustomerId: '',

    selectedPlz: '',


    //needed for usecase taxi
    relevantArea: {
      minOrderAmount: 0,
      fee: 0,
    },

    buyersProfile: {
      paymentMethods: [
        //{sourceId: 'irjsdfkdfg', label:'Visa XXXX-234', exp:"5/2055"},{...}
      ]
    },

    userPreferences: {
      email: '', // used as ID
      favFoods: [],
      favDrinks: [],
      favCarts: [],
      allergenesFilter: [],
      storesFilter: [],
      favoriteStores: [],
    },

    // userSettings: {
    //   info: {},
    //   allergenes: {},
    //   // favcartsRestaurant: {
    //   //     drinks: [],
    //   //     foods: [
    //   //         // {
    //   //         //     id: 'foodId',
    //   //         //     nameToDisplay: 'Pizza Salami',
    //   //         //     vol: '30 cm',
    //   //         //     extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
    //   //         //     variantsSelected: [], //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
    //   //         //     stylesSelected: [] //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
    //   //         // }
    //   //     ],
    //   //     carts: [
    //   //         // { ... }
    //   //     ]
    //   // },
    //   favcartsApp: {
    //     drinks: [
    //       // 'id1', 'id2'
    //     ],
    //     foods: [],
    //     carts: []
    //   }
    // },

    appSettings: {
      pushToken: '',
      pushTopicsList: [],
      pushTopics: {
        // orderState: false,
        news: true,
        coupons: true,
        loyalty: true,
      }
    },

    news: [],
    unreadNews: [],
    numberOfFavs: 0,

    //PWA specific
    pwaInstalled: false,
    showInstallPwa: false,
    showAddedOverlay: false,

    showLoading: false,
    currentNext: '',
    currentQuery: '',
    currentContext: {
      ctx: '',
      param: null
    },

    showMyPopupFirmenauswahl: false,
    forCompany: '',

    showMyPopup: false,
    showItemAdditionals: false,

    showDialogContainer: false,
    selectedDialog: '',
    secondSelectedDialog: '',

    itemForAddDirectly: null,

    searchIsRenderedNow: false,

    homepageSliderImages: [],

    isOnline: true,
  },
  mutations: {

    swActive(state, v) {
      state.swActive = v;
    },

    forCompany(state, v) {
      state.forCompany = v;
    },
    setEnableOrderModeSelection(state, v) {
      state.enableOrderModeSelection = v;
    },
    setEnableOrderModeSelectionWithTime(state, v) {
      state.enableOrderModeSelectionWithTime = v;
    },
    restoreSelectedOrderModeByUser(state, mode) {
      state.selectedOrderModeByUser = mode;
    },
    setSelectedOrderModeByUser(state, mode) {
      state.selectedOrderModeByUser = mode;
      let exp = exp = 1 * 60 * 60 * 1000; //1 hours
      Vue.ls.set('selectedOrderModeByUser', state.selectedOrderModeByUser, exp);
    },
    searchBarVisible(state, v) {
      state.searchBarVisible = v;
    },
    searchIsRenderedNow(state, v) {
      state.searchIsRenderedNow = v;
    },
    itemForAddDirectly(state, v) {
      state.itemForAddDirectly = v;
    },
    setIsOnline(state, v) {
      state.isOnline = v;
    },

    hidePrices(state, newValue) {
      state.hidePrices = newValue;
    },

    selectedPickupTime(state, newValue) {
      state.selectedPickupTime = newValue;
      if (newValue) {
        let exp = exp = 2 * 60 * 60 * 1000; //2 hours
        Vue.ls.set('selectedPickupTime', state.selectedPickupTime, exp);
      } else {
        Vue.ls.remove('selectedPickupTime');
      }
    },
    selectedDialog(state, newValue) {
      if (newValue && !state.showDialogContainer) {
        state.secondSelectedDialog = '';
      }
      state.selectedDialog = newValue;
    },
    secondSelectedDialog(state, newValue) {
      state.secondSelectedDialog = newValue;
    },
    showMyPopupFirmenauswahl(state, newValue) {
      state.showMyPopupFirmenauswahl = newValue;
    },
    showMyPopup(state, newValue) {
      state.showMyPopup = newValue;
    },
    showItemAdditionals(state, newValue) {
      state.showItemAdditionals = newValue;
    },
    showDialogContainer(state, newValue) {
      state.showDialogContainer = newValue;
    },
    secToken(state, newValue) {
      state.secToken = newValue;
    },
    currentItemId(state, newValue) {
      state.currentItemId = newValue;
    },
    deviceClass(state, newValue) {
      state.deviceClass = newValue;
    },
    appLoaded(state, newValue) {
      state.appLoaded = newValue;
    },
    showSelectFiliale(state, newValue) {
      state.showSelectFiliale = newValue;
    },
    continueBack(state, newValue) {
      state.continueBack = newValue;
    },
    page(state, newValue) {
      state.page = newValue;
    },
    pages(state, values) {
      Vue.set(state, 'pages', [...values]);
    },
    //only for iframes
    // yA(state, newValue) {
    //     state.yA = newValue;
    // },
    deliveryFee(state, newValue) {
      state.deliveryFee = newValue;
    },
    isLoggingOut(state, newValue) {
      state.isLoggingOut = newValue;
    },
    numberOfFavs(state, newValue) {
      state.numberOfFavs = newValue;
    },
    appSettings(state, newValue) {
      if (newValue && !isEmptyObject(newValue)) {
        Object.assign(state.appSettings, newValue);
      }
      Vue.ls.set('appSettings', state.appSettings);
    },
    relevantArea(state, area) {
      console.log('commit relevantArea: ', JSON.stringify(area));
      Object.assign(state.relevantArea, area);
    },
    selectedTime(state, newValue) {
      Object.assign(state.selectedTime, newValue);
    },
    globals(state, newValue) {
      Object.assign(state.globals, newValue);
      Vue.ls.set('globals', state.globals);
    },
    openingBegin(state, newValue) {
      state.openingBegin = newValue;
    },
    hideScroll(state, newValue) {
      state.hideScroll = newValue;
    },
    hideToolbar(state, newValue) {
      state.hideToolbar = newValue;
    },
    showSearchIcon(state, newValue) {
      state.showSearchIcon = newValue;
    },
    deleteAllCartItems(state) {
      // for (let i = 0; i < state.cartItems.length; i++) {
      // i++;
      state.cartItems.splice(0, state.cartItems.length);
      // Vue.delete(state.cartItems, i);
      // }

      //update cartSum
      updateCartSum(state);

      Vue.ls.remove('cartItems');
    },
    lastOrders(state, orders) {
      for (let order of orders) {
        doUpdateOrder(state, order)
      }
      // Vue.set(state, 'lastOrders', [...orders]);
      Vue.ls.set('lastOrders', state.lastOrders);
    },
    updateOrder(state, value) {
      if (!value || !value.uniqueOrderId) {
        return
      }
      doUpdateOrder(state, value);
      Vue.ls.set('lastOrders', state.lastOrders);
    },
    news(state, values) {
      Vue.set(state, 'news', [...values]);
      Vue.ls.set('news', state.news);
    },
    userPreferences(state, value) {
      Object.assign(state.userPreferences, value);
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    favFoods(state, values) {
      Object.assign(state.userPreferences.favFoods, [...values]);
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    favDrinks(state, values) {
      Object.assign(state.userPreferences.favDrinks, [...values]);
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    favCarts(state, values) {
      Object.assign(state.userPreferences.favCarts, [...values]);
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    favoriteStores(state, values) {
      let clean = values.filter(s => !!s.filialnummer);
      Object.assign(state.userPreferences.favoriteStores, [...clean]);
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    allergenesFilter(state, values) {
      state.userPreferences.allergenesFilter = values;
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    getNewsByTag: (state) => (tag) => {
      let n = state.news.find(news => news.tag === tag);
      if (n) {
        return n;
      }
      return undefined;
    },
    getNewsById: (state) => (id) => {
      return state.news.find(news => news.id === id);
    },
    unreadNews(state, values) {
      Vue.set(state, 'unreadNews', [...values]);
    },
    currentNext(state, newValue) {
      // console.log('??? setCurrentNext = '+newValue);
      state.currentNext = newValue;
    },
    currentQuery(state, newValue) {
      state.currentQuery = newValue;
    },
    currentContext(state, newValue) {
      Object.assign(state.currentContext, newValue);
      // state.currentContext = newValue;
    },
    clearContext(state, newValue) {
      state.currentContext.ctx = '';
      state.currentContext.param = null;
    },
    showLoading(state, newValue) {
      state.showLoading = newValue;
    },
    loginPostprocessing(state, newValue) {
      state.loginPostprocessing = newValue;
    },
    duringRegistration(state, newValue) {
      state.duringRegistration = newValue;
    },
    loggedIn(state, newValue) {
      state.loggedIn = newValue;
      if (!newValue) {
        Object.assign(state.user, {
          fuid: '',
          name: '',
          email: '',
          phone: ''
        });
      }
      ebus.$emit('loggedInWasUpdatedTo', !!newValue);
    },
    stripeLoaded(state, newValue) {
      state.stripeLoaded = newValue;
    },

    stripeCustomerId(state, newValue) {
      state.stripeCustomerId = newValue;
    },

    user(state, newValue) {
      Object.assign(state.user, newValue);
    },

    buyersProfile(state, newValue) {
      Object.assign(state.buyersProfile, newValue);
      Vue.ls.set('buyersProfile', state.buyersProfile);
    },

    paymentMethods(state, newValue) {
      Object.assign(state.buyersProfile, {paymentMethods: newValue || []});
      Vue.ls.set('buyersProfile', state.buyersProfile);
    },

    barTitle(state, newValue) {
      state.barTitle = newValue;
    },
    cartId(state, newValue) {
      state.cartId = newValue;
      state.fromWidget = !!(newValue && newValue.length > 0);
    },
    orderArea(state, newValue) {
      state.orderArea = newValue;
    },
    inhouse(state, newValue) {
      let n = !!newValue; //true/false
      if (state.inhouse !== n) {
        state.inhouse = n;
      }
      // if (state.inhouse) {
      //   ebus.$emit('inhouse');
      // }
    },
    table(state, newValue) {
      try {
        let n = parseInt(newValue, 10);
        if (state.table !== n) {
          state.table = n;
        }
      } catch (e) {

      }
    },
    selectedCategory(state, newValue) {
      Object.assign(state.selectedCategory, cloneMe(newValue));
    },
    remoteTime(state, newValue) {
      Object.assign(state.remoteTime, newValue);
    },

    pwaInstalled(state, newValue) {
      state.pwaInstalled = newValue;
    },
    showInstallPwa(state, newValue) {
      state.showInstallPwa = newValue;
    },
    showAddedOverlay(state, newValue) {
      state.showAddedOverlay = newValue;
    },

    appconfig(state, _appconfig) {
      _appconfig.loaded = true;

      let existingTakeaway = state.appconfig.takeAway;
      _appconfig.takeAway = Object.assign(existingTakeaway, _appconfig.takeAway || {});

      let existingDelivery = state.appconfig.delivery;
      _appconfig.delivery = Object.assign(existingDelivery, _appconfig.delivery || {});

      Object.assign(state.appconfig, _appconfig);
      delete state.appconfig.takeAway.orderingEnabled;
      delete state.appconfig.delivery.orderingEnabled;
      Vue.ls.set('appconfig', state.appconfig);
    },
    // dcontext(state, payload) {
    //     // getters.appconfig.takeAway.delayInMinutes = takeawayData.delayInMinutes;
    //     Object.assign(state.dcontext, payload);
    //     // for (const [key, value] of Object.entries(takeawayData)) {
    //     //     Object.assign(state.dcontext[key], value);
    //     // }
    //     console.log('??? dcontext commited', payload);
    // },
    day1(state, payload) {
      Object.assign(state.day1, payload);
    },

    day2(state, payload) {
      Object.assign(state.day2, payload);
    },

    day3(state, payload) {
      Object.assign(state.day3, payload);
    },
    addFavFood(state, newValue) {
      state.userPreferences.favFoods.unshift(newValue);
    },
    addFavDrink(state, newValue) {
      state.userPreferences.favDrinks.unshift(newValue);
    },

    // removeFavDrink(state, newValue) {
    //     if (state.userPreferences.favDrinks.length > 0) {
    //         let i = 0;
    //         for (let item of state.userPreferences.favDrinks) {
    //             if (item.id === newValue) {
    //                 break;
    //             }
    //             i++;
    //         }
    //         console.log('??? remove drink at index ' + i);
    //         Vue.delete(state.userPreferences.favDrinks, i);
    //     }
    // },
    removeFavFood(state, itemId) {
      if (state.userPreferences.favFoods.length > 0) {
        let i = 0;
        for (let item of state.userPreferences.favFoods) {
          if (item.id === itemId) {
            break;
          }
          i++;
        }
        Vue.delete(state.userPreferences.favFoods, i);
      }
      Vue.ls.set('userPreferences', state.userPreferences);
    },
    removeFavDrink(state, itemId) {
      if (state.userPreferences.favDrinks.length > 0) {
        let i = 0;
        for (let item of state.userPreferences.favDrinks) {
          if (item.id === itemId) {
            break;
          }
          i++;
        }
        Vue.delete(state.userPreferences.favDrinks, i);
      }
      Vue.ls.set('userPreferences', state.userPreferences);
    },

    replaceFavFoods(state, favFoods) {
      state.userPreferences.favFoods.splice(0, state.userPreferences.favFoods.length);
      for (let item of favFoods) {
        state.userPreferences.favFoods.push(item);
      }
    },
    replaceFavDrink(state, favFoods) {
      state.userPreferences.favDrinks.splice(0, state.userPreferences.favDrinks.length);
      for (let item of favFoods) {
        state.userPreferences.favDrinks.push(item);
      }
    },

    replaceFavcartsApp(state, favcatsApp) {
      console.log('replaceFavcartsApp ', favcatsApp);
      Object.assign(state.userPreferences.favCarts, favcatsApp);
      // state.userPreferences.favFoods.splice(0, state.userPreferences.favFoods.length);
      // for (let favFood of favFoods) {
      //     state.userPreferences.favFoods.push(favFood);
      // }
    },

    updateCartItem(state, payload) {
      if (state.cartProtected) {
        //do nothing when the cart is protected
        return;
      }
      try {
        let cartItemId = payload.cartItemId;
        let p = payload.propsToUpdate;
        let item = state.cartItems.find(i => i.cartItemId === cartItemId);
        if (item && p) {
          Object.assign(item, p);

          updateCartSum(state);

          //update cartItems in localStorage
          ebus.$emit('storeCart', cloneMe(state.cartItems));

          console.log('einlösen item updated in store extras: ' + item.extrasToDisplay);

        } else {
          console.log('einlösen item missing in updateCartItem');
        }
      } catch (e) {
        console.log('einlösen error in updateCartItem: ' + e.message);
      }
    },

    incrementCartItem(state, itemToIncrement) {
      if (state.cartProtected) {
        //do nothing when the cart is protected
        return;
      }
      for (let item of state.cartItems) {
        if (item.cartItemId === itemToIncrement.cartItemId) {

          if (!checkInventoryData(state, item)) {
            return;
          }

          item.count += 1;
          item.itemTotal = (item.sizePrice + item.sumOfExtras) * item.count;
          // item.takeAwayItemTotal = (item.takeAwaySizePrice + item.sumOfExtras) * item.count;
          //FIXME add deliveryTotal
          break;
        }
      }

      //update cartSum
      updateCartSum(state);

      //update cartItems in localStorage
      ebus.$emit('storeCart', cloneMe(state.cartItems));
    },

    deleteCartItem(state, cartItemToDelete) {
      let i = -1;
      let found = false;
      for (let item of state.cartItems) {
        i++;
        if (item.cartItemId === cartItemToDelete.cartItemId) {
          Vue.delete(state.cartItems, i);
          // state.cartItems.splice(i, 1);
          found = true;
          break;
        }
      }
      if (!found) {
        return;
      }

      //update cartSum
      updateCartSum(state);

      //update cartItems in localStorage
      ebus.$emit('storeCartForce', cloneMe(state.cartItems));
    },

    removeSpecialCartItem(state, itemId) {
      let i = -1;
      let any = false;
      for (let item of state.cartItems) {
        i++;
        if (item.id === itemId) {
          any = true;
          Vue.delete(state.cartItems, i);
        }
      }

      if (any) {
        //update cartSum
        updateCartSum(state);

        //update cartItems in localStorage
        ebus.$emit('storeCartForce', cloneMe(state.cartItems));
      }
    },

    decrementCartItem(state, itemToDecrement) {
      if (state.cartProtected) {
        //do nothing when the cart is protected
        return;
      }
      let i = -1;
      for (let item of state.cartItems) {
        i++;
        if (item.cartItemId === itemToDecrement.cartItemId) {

          if (item.count > 1) {
            item.count -= 1;
            item.itemTotal = (item.sizePrice + item.sumOfExtras) * item.count;
            item.takeAwayItemTotal = (item.takeAwaySizePrice + item.sumOfExtras) * item.count;
            if (item.originalItemTotal) {
              item.originalItemTotal -= item.originalSizePrice;
            }
            //FIXME add deliveryTotal
          } else {
            //remove item completely
            Vue.delete(state.cartItems, i);
            // state.cartItems.splice(i, 1);
          }
          break;
        }
      }

      //update cartSum
      updateCartSum(state);

      //update cartItems in localStorage
      ebus.$emit('storeCartForce', cloneMe(state.cartItems));
    },

    // protectCart(state, value) {
    //     state.cartProtected = value;
    // },

    restoreCartItems(state, params) {
      if (state.cartProtected) {
        //do nothing when the cart is protected
        console.log('prevented double execution of restoreCartItems');
        return;
      }
      if (state.cartItems.length > 0) {
        console.log('do not restoreCartItems because it is already filled');
        return;
      }
      state.cartProtected = true;

      let items = params.items;
      if (items && items.length > 0) {

        //enable protection

        console.log('cartProtected = true');
        setTimeout(() => {
          state.cartProtected = false;
          console.log('cartProtected = false');
        }, 3000);

        for (let _item of items) {
          if (_item.validUntil && (_item.validUntil < Date.now())) {
            continue;
          }
          try {
            let item = cloneMe(_item);
            //identify if item+extras already exists and increase the count
            let isNew = true;
            let isCoupon = !item.applicable && ('redeemed' in item || ('couponCode' in item));
            // let isCoupon = 'isCoupon' in item;

            //ignore invald coupons
            if (isCoupon && (Date.now() > item.validUntil)) {
              return;
            }

            if (!isCoupon) {
              //ignore items without names
              if (!item.nameToDisplay) {
                return;
              } else if (!params.immediate) {
                // if (item.type !== qconst.type$generic) {
                //   //ignore items which do not exist
                //   let menu = menustore.state.foodMenu;
                //   if (item.type === qconst.type$drinkOrder) {
                //     menu = menustore.state.drinkMenu;
                //   }
                //   let itm = getItemById(menu, item.id);
                //   if (!itm) {
                //     return;
                //   }
                // }
              }
            } else {
              item.isCoupon = true;
            }

            //prevent multiple coupons that are not combinable
            let numberOfUncombinable = 0;
            for (let itm of state.cartItems) {
              let isItmCoupon = 'combinable' in itm;
              if (isItmCoupon && !itm.combinable) {
                numberOfUncombinable++;
              }

              if (!isCoupon && !isItmCoupon && item.id === itm.id && item.vol === itm.vol && gangEquals(item, itm)) {
                if (item.extrasToDisplay.join(', ') === itm.extrasToDisplay.join(', ')) {
                  //item already exists
                  isNew = false;
                  itm.count += item.count;
                  itm.itemTotal = (itm.sizePrice + itm.sumOfExtras) * itm.count;
                  itm.takeAwayItemTotal = (itm.takeAwaySizePrice + itm.sumOfExtras) * itm.count;
                  //FIXME add delivery
                  // break;
                }
              } else if (isCoupon && isItmCoupon) {
                if (item.couponCode && itm.couponCode && (item.couponCode === itm.couponCode)) {
                  isNew = false;
                }
                // break;
              }

              console.log('itemTotal = ' + itm.itemTotal);
              console.log('takeAwayItemTotal = ' + itm.takeAwayItemTotal);
              console.log('takeAwaySizePrice = ' + itm.takeAwaySizePrice);
            }

            if (isNew) {
              if (!isCoupon || numberOfUncombinable < 1) {

                if (isCoupon) {
                  item.nameToDisplay = displayCouponType(item);
                  // } else {
                  //     delete item.days;
                }

                state.cartItems.push(item);

                //sort by gang
                state.cartItems.sort((a, b) => {
                  let gangA = '' + a.gang;
                  let gangB = '' + b.gang;
                  return gangB.localeCompare(gangA);
                });
              }
            }


            //update cartSum
            updateCartSum(state);


          } catch (e) {
            console.log('Error protected itemToCart: ' + e.message);
          }
        }//of items loop

        //save cartItems in localStorage with timestap
        console.log('restored cartItems length=' + state.cartItems.length);
      } else {
        state.cartProtected = false;
      }

    },

    appliedDiscounts(state, list) {
      if (Array.isArray(list)) {
        state.appliedDiscounts = list;
      }
    },

    homepageSliderImages(state, values) {
      state.homepageSliderImages = values.filter(v => !v.dummy);
      Vue.ls.set('homepageSliderImages', state.homepageSliderImages);
    },

    addItemToCart(state, params) {
      try {
        if (state.cartProtected) {
          //do nothing when the cart is protected
          return;
        }
        // if (!sharedStoresStates.getIsStoreSelected()) {
        //   ebus.$emit('showInfo', {
        //     title: 'Bitte zuerst eine Filiale auswählen, um den Korb mit Waren zu füllen.',
        //     text: ''
        //   });
        //   ebus.$emit('goto', {name: 'Filialen'});
        //   return;
        // }
        if (!flags.getters.orderingEnabled) {
          ebus.$emit('showInfo', {
            title: 'Bestellungen sind in dieser Filiale zur Zeit nicht möglich. Bitte versuche es später noch einmal.',
            text: ''
          });
          return;
        }

        let itemToAdd = params.item;
        if (!itemToAdd.onlineGutschein
          && !itemToAdd.ticket
        ) {
          if (state.enableOrderModeSelection && !state.selectedOrderModeByUser) {
            ebus.$emit('showOrderModeSwitchDialog', true);
            return;
          }
        }

        // removeGlobalKey('userWantsToAddItemToCart');

        console.log('addDirectly: addItemToCart');
        console.log('!!!!!!!!!!!! addItemToCart: ', params.item);
        let _item = params.item;
        if (!_item) {
          return;
        }
        let item = cloneMe(_item);
        let parentCat = findParentCatByItem(item);
        if (parentCat) {
          item.parentCat = parentCat;

          //custom geschnitten
          // if (parentCat.categoryDE.toLowerCase().startsWith("brot")) {
          //   let cartItemWithAllValues = cloneMe(item);
          //   let _item = getItemById(menustore.state.foodMenu, item.id);
          //   if (!_item) {
          //     _item = getItemById(menustore.state.drinkMenu, item.id);
          //   }
          //   if (_item) {
          //     Object.assign(cartItemWithAllValues, _item);
          //     // cartItemWithAllValues.noHtmlName =todo
          //   }
          //
          //   if (!params.noAvailabiltyChecks) {
          //     setGlobalKeyValue('itemBrotGeschnitten', cartItemWithAllValues);
          //     setTimeout(() => {
          //       ebus.$emit('showQuestion', {
          //         quest: 'Möchtest du das Brot geschnitten erhalten?',
          //         // text: 'Kurzanleitung:<br><ul>' +
          //         //   '<li>iPhones: Nutze die Standard-Kamera, keine App notwendig</li>' +
          //         //   '<li>Android-Phones: Probiere die Standard-Kamera aus, ansonsten installiere die empfohlene QR-Code App</li>' +
          //         //   '</ul>' +
          //         yesLabel: 'Geschnitten',
          //         noLabel: 'Nein',
          //         cb: 'cb-brotGeschnitten'
          //       });
          //     }, 200);
          //   }
          // }

        }
        //identify if item+extras already exists and increase the count
        let isNew = true;
        let isCoupon = !item.applicable && ('redeemed' in item || ('couponCode' in item));
        // let isCoupon = 'isCoupon' in item;

        //ignore invalid coupons or already redeemed coupons
        if ((isCoupon && (Date.now() > item.validUntil)) || !!item.redeemed) {
          console.log('addItemToCard check 2');
          return;
        }

        if (!isCoupon) {
          console.log('addItemToCard check 3');

          if (item.verkauft) {
            ebus.$emit('showInfo', {
              title: 'Der Artikel <span style="text-decoration: underline;">'
                + item.nameToDisplay + '</span> ist ausverkauft!',
              text: ''
            });
            return;
          }

          if (!checkInventoryData(state, item)) {
            return;
          }

          //ignore items without names
          if (!item.nameToDisplay || !item.id) {
            console.log('addItemToCard check 4.1');
            return;
          } else if (!item.id.startsWith('special') && (item.bestand === 0 || item.verkauft)) {
            console.log('addItemToCard check 4.2');
            if (!params.immediate) {
              alert('Dieser Artikel ist bereits ausverkauft!');
            }
            return;
          } else if (!params.immediate) {
            console.log('addItemToCard check 4.3');
            try {
              if (!item.id.startsWith('specialUnique')) {
                if (item.type !== qconst.type$generic) {
                  //ignore items which do not exist
                  let menu = menustore.state.foodMenu;
                  if (item.type === qconst.type$drinkOrder) {
                    menu = menustore.state.drinkMenu;
                  }
                  let itm = getItemById(menu, item.id);
                  if (!itm) {
                    return;
                  }
                }
              }
              console.log('addItemToCard check 4.4');
            } catch (eee) {
              console.log('addItemToCard check 4.5');
            }


          }
        } else {
          item.isCoupon = true;
          // if (!item.articleNo) {
          //     if (!params.immediate) {
          //         alert('Dieser Coupon kann aktuell nicht im Online-Shop eingelöst werden!');
          //     }
          //     return;
          // }
        }

        console.log('addItemToCard check 5');

        //tickets cannot be ordered with notickets
        let hasTicket = !!item.ticket;
        let hasNonTicket = !item.ticket;

        //prevent multiple coupons that are not combinable
        let numberOfUncombinable = 0;
        let existingItem = null;
        for (let cartItem of state.cartItems) {

          if (cartItem.ticket) {
            hasTicket = true;
          } else {
            hasNonTicket = true;
          }

          let isItmCoupon = 'combinable' in cartItem;
          if (isItmCoupon && !cartItem.combinable) {
            numberOfUncombinable++;
          }

          if (item.id.startsWith('stempel-') && cartItem.id.startsWith('stempel-')) {
            isNew = false;
            existingItem = cartItem;
          } else if (item.id === 'specialUniqueOnlineServiceFee' && cartItem.id === 'specialUniqueOnlineServiceFee') {
            isNew = false;
            existingItem = cartItem;
          } else if (item.id === 'specialUniqueDeliveryFee' && cartItem.id === 'specialUniqueDeliveryFee') {
            isNew = false;
            existingItem = cartItem;
          } else if (!isCoupon && !isItmCoupon && item.id === cartItem.id && item.vol === cartItem.vol && gangEquals(item, cartItem)) {
            if (item.extrasToDisplay.join(', ') === cartItem.extrasToDisplay.join(', ')
              && (item.notes || '') === (cartItem.notes || '')
            ) {
              //item already exists
              isNew = false;
              cartItem.count += item.count;
              cartItem.itemTotal = (cartItem.sizePrice + cartItem.sumOfExtras) * cartItem.count;
              cartItem.takeAwayItemTotal = (cartItem.takeAwaySizePrice + cartItem.sumOfExtras) * cartItem.count;
              //FIXME add delivery
              // break;
            }
          } else if (isCoupon && isItmCoupon) {
            if (item.couponCode && cartItem.couponCode && (item.couponCode === cartItem.couponCode)) {
              isNew = false;
              existingItem = cartItem;
            }
            // break;
          }

          console.log('itemTotal = ' + cartItem.itemTotal);
          console.log('takeAwayItemTotal = ' + cartItem.takeAwayItemTotal);
          console.log('takeAwaySizePrice = ' + cartItem.takeAwaySizePrice);
        }

        if (hasTicket && hasNonTicket) {
          alert('Tickets bitte nicht zusammen mit Getränken oder Speisen bestellen!');
          return;
        }

        if (isNew) {
          if (!isCoupon || numberOfUncombinable < 1) {

            if (isCoupon) {
              item.nameToDisplay = displayCouponType(item);
              // } else {
              //     delete item.days;
            }

            state.cartItems.push(item);

            console.log('cartItem has been added: ' + item.id);

            //sort by gang
            state.cartItems.sort((a, b) => {
              let gangA = '' + a.gang;
              let gangB = '' + b.gang;
              return gangB.localeCompare(gangA);
            });
          }
        } else {
          console.log('item already exists in cartItems: ' + JSON.stringify(item));
          if (existingItem && existingItem.sizePrice !== item.sizePrice) {
            //update existing item
            Object.assign(existingItem, item);
          }
        }

        updateCartSum(state);


        //save cartItems in localStorage with timestap
        if (!params.immediate) {
          ebus.$emit('storeCart', cloneMe(state.cartItems));
        }
        if (!params.addSilent) {
          showAdded();
        }
      } catch (e) {
        console.log('Error itemToCart to cartItems: ' + e.message);
      }
    },
  },
  getters: {
    swActive: (state) => {
      return state.swActive;
    },
    availableOrderModes: (state, getters, rootState, rootGetters) => {
      return getAvailableOrderModes(state, rootGetters);
    },
    showOrderModeSwitcher: (state, getters, rootState, rootGetters) => {
      if (!state.enableOrderModeSelection) {
        return false;
      }
      const modesCount = getAvailableOrderModes(state, rootGetters).length;
      if (modesCount === 0) {
        return false;
      }
      return !(getAvailableOrderModes(state, rootGetters).length === 1 && getters.selectedOrderModeByUser);
    },
    enableBestand: (state) => {
      return state.enableBestand;
    },
    forCompany: (state) => {
      return state.forCompany;
    },
    selectedOrderModeByUser: (state) => {
      return state.selectedOrderModeByUser;
    },
    appLoaded: (state) => {
      return state.appLoaded;
    },
    showSearch: (state) => {
      return state.showSearch;
    },
    searchBarVisible: (state) => {
      return state.searchBarVisible;
    },
    searchIsRenderedNow: (state) => {
      return state.searchIsRenderedNow;
    },
    itemForAddDirectly: (state) => {
      return state.itemForAddDirectly;
    },
    isProdEnv() {
      return PROD_ENV;
    },
    hidePrices: (state) => {
      return state.hidePrices;
    },
    showLoading: (state) => state.showLoading,
    showAddedOverlay: (state) => state.showAddedOverlay,

    getParentCategoryByItem: (state) => (item) => {
      return findParentCatByItem(item);
    },

    isOnline: (state) => state.isOnline,

    globals: (state) => state.globals,

    cartProtected: (state) => {
      return state.cartProtected;
    },
    userPreferences: (state) => {
      return state.userPreferences;
    },
    cartItems: (state) => {
      return state.cartItems;
    },
    appliedDiscounts: (state) => {
      return state.appliedDiscounts;
    },
    selectedPickupTime: (state) => {
      if (stores.state.selectedStore.filialnummer) {
        let t = state.selectedPickupTime;
        if (t) {
          let lt = Vue.ls.get('selectedPickupTime');
          if (lt) {
            return lt;
          }
        }
      }

      return '';
    },
    inhouse: (state) => {
      return state.inhouse;
    },
    table: (state) => {
      return state.table;
    },
    payerSum: (state) => {
      return state.payerSum;
    },
    cartSum: (state) => {
      return state.cartSum;
    },
    drinkSum: (state) => {
      return state.drinkSum;
    },
    appSettings: (state) => {
      return state.appSettings;
    },
    selectedDialog: (state) => {
      return state.selectedDialog;
    },
    secondSelectedDialog: (state) => {
      return state.secondSelectedDialog;
    },
    showMyPopupFirmenauswahl: (state) => {
      return state.showMyPopupFirmenauswahl;
    },
    showMyPopup: (state) => {
      return state.showMyPopup;
    },
    showItemAdditionals: (state) => {
      return state.showItemAdditionals;
    },
    showDialogContainer: (state) => {
      return state.showDialogContainer;
    },
    secToken: (state) => {
      return state.secToken;
    },
    loggedIn: (state) => {
      return state.loggedIn;
    },
    hasStempelInCart: (state) => {
      for (let itm of state.cartItems) {
        if (itm.id && itm.id.startsWith('stempel-')) {
          return true;
        }
      }
      return false;
    },
    // restId: (state) => {
    //   return state.restaurantId;cartItems
    // },
    appconfig: (state) => {
      return state.appconfig;
    },
    showSelectFiliale: (state) => {
      return state.showSelectFiliale;
    },
    continueBack: (state) => {
      return state.continueBack;
    },
    storeName: (state) => {
      return state.brandName;
    },
    page: (state) => {
      return state.page;
    },
    pages: (state) => {
      return state.pages;
    },
    selectedCategory: (state) => {
      return state.selectedCategory;
    },
    // storeId: (state) => {
    //   return state.storeId;
    // },
    selectedTime: (state) => {
      return state.selectedTime;
    },
    paymentMethods: (state) => {
      return state.buyersProfile.paymentMethods;
    },

    // delayInMinutes: (state) => {
    //     return state.getters.appconfig.takeAway.delayInMinutes;
    // },

    // openingHours: (state) => (day) => {
    //     if (Object.keys(state.getters.appconfig.takeAway.openingHours).length === 0) {
    //         return {
    //             opened: false,
    //             a: {fromHour: 0, fromMinute: 0, tillHour: 0, tillMinute: 0},
    //             b: {fromHour: 0, fromMinute: 0, tillHour: 0, tillMinute: 0}
    //         }
    //     } else {
    //         return state.getters.appconfig.takeAway.openingHours['' + day];
    //     }
    //     // let category = menustore.state.drinkMenu.find(category => category.id === categoryId);
    //     // return category.drinks.find(drink => drink.id === itemId);
    // },

    lastOrders: (state) => {
      return state.lastOrders.sort((a, b) => b.createdAt - a.createdAt);
    },

    news: (state) => {
      return state.news.sort((a, b) => b.publishDate - a.publishDate);
    },

    getNewsByTag: (state) => (tag) => {
      let n = state.news.find(news => news.tag === tag);
      if (n) {
        return n;
      }
      return undefined;
    },

    getNewsById: (state) => (id) => {
      return state.news.find(news => news.id === id);
    },

    unreadNews: (state) => {
      return state.unreadNews.sort((a, b) => b.createdAt - a.createdAt);
    },

    getPageByName: (state) => (name) => {
      return state.pages.find(page => page.name === name);
    },

    numberOfFavs: (state) => {
      return state.numberOfFavs;
    },
    // unreadNews: (state) => {
    //     let news = state.news.sort((a, b) => b.createdAt - a.createdAt);
    //     let unreadNews = [];
    //     let newsRead = {};
    //     let lnewsRead = this.$ls.get('newsRead');
    //     if (lnewsRead) {
    //         newsRead = JSON.parse(lnewsRead);
    //     }
    //     for (let n of news) {
    //         if (!newsRead[n.tag]) {
    //             unreadNews.push(n);
    //         }
    //     }
    //     return unreadNews;
    // },

    favFoods: (state) => {
      return state.userPreferences.favFoods;
    },

    favDrinks: (state) => {
      return state.userPreferences.favDrinks;
    },

    allergenesFilter: (state) => {
      return state.userPreferences.allergenesFilter;
    },

    storesFilter: (state) => {
      return state.userPreferences.storesFilter;
    },

    favFoodById: (state) => (itemId) => {
      return state.userPreferences.favFoods.find(i => i.id === itemId);
    },

    favDrinkById: (state) => (itemId) => {
      return state.userPreferences.favDrinks.find(i => i.id === itemId);
    },

    relevantArea: (state) => {
      return state.relevantArea;
    },

    currentItemId: (state) => {
      return state.currentItemId;
    },
    homepageSliderImages: (state) => {
      return state.homepageSliderImages
    },
    deviceClass: (state) => {
      //xxs, xs, md
      return state.deviceClass;
    },

  },
  actions: {
    openMyPopup({commit}) {
      commit('showMyPopup', true);
      document.body.classList.add('no-scroll');
    },
    closeMyPopup({commit}) {
      commit('showMyPopup', false);
      document.body.classList.remove('no-scroll');
    },


    openMyPopupFirmenauswahl({commit}) {
      commit('showMyPopupFirmenauswahl', true);
      document.body.classList.add('no-scroll');
    },
    closeMyPopupFirmenauswahl({commit}) {
      commit('showMyPopupFirmenauswahl', false);
      document.body.classList.remove('no-scroll');
    },
  },
})
